<img *ngIf="image.image" [src]="image.image" class="clickable" height="250px" (click)="viewOriginal()">